package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.example.mystybag.core.ui.theme.LocalTheme.carosoft
import androidx.compose.ui.text.font.FontWeight
import com.example.mystybag.appCore.logic.pages.LeaveReviewViewModel
import com.example.mystybag.appCore.model.pages.ReviewCouldBeBetterAspect
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.extensions.scrollEdgeFade
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.DefaultButtonSize
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p56
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.ui.views.UIView
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.core.resources.SRC

// Figma: star 40x38, unmarked #DDDFDE, marked #EFC200
private val StarUnmarkedColor = Color(0xFFDDDFDE)
private val StarMarkedColor = Color(0xFFEFC200)

@Composable
private fun StarIcon(
    filled: Boolean,
    modifier: Modifier = Modifier,
    onClick: () -> Unit = {}
) {
    Box(
        modifier = modifier
            .size(40.dp, 38.dp)
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        androidx.compose.foundation.Image(
            modifier = Modifier.size(40.dp, 38.dp),
            painter = painterResource(SRC.images.star_6),
            contentDescription = null,
            colorFilter = ColorFilter.tint(if (filled) StarMarkedColor else StarUnmarkedColor)
        )
    }
}

@Composable
private fun getReviewCategoryLabel(labelKey: String): String {
    return try {
        when (labelKey) {
            "collection_experience" -> sharedString(SR.strings.collection_experience)
            "food_quality" -> sharedString(SR.strings.food_quality)
            "variety_of_contents" -> sharedString(SR.strings.variety_of_contents)
            "food_quantity" -> sharedString(SR.strings.food_quantity)
            "review_rating_freshness" -> sharedString(SR.strings.review_rating_freshness)
            "review_rating_quality" -> sharedString(SR.strings.review_rating_quality)
            "review_rating_variety" -> sharedString(SR.strings.review_rating_variety)
            "review_rating_value" -> sharedString(SR.strings.review_rating_value)
            "review_rating_taste" -> sharedString(SR.strings.review_rating_taste)
            "review_rating_presentation" -> sharedString(SR.strings.review_rating_presentation)
            "review_rating_portion_size" -> sharedString(SR.strings.review_rating_portion_size)
            "review_rating_coffee_quality" -> sharedString(SR.strings.review_rating_coffee_quality)
            "review_rating_service" -> sharedString(SR.strings.review_rating_service)
            "review_rating_atmosphere" -> sharedString(SR.strings.review_rating_atmosphere)
            "review_rating_product_quality" -> sharedString(SR.strings.review_rating_product_quality)
            "review_rating_packaging" -> sharedString(SR.strings.review_rating_packaging)
            "review_rating_service_quality" -> sharedString(SR.strings.review_rating_service_quality)
            "review_rating_professionalism" -> sharedString(SR.strings.review_rating_professionalism)
            "review_rating_hygiene" -> sharedString(SR.strings.review_rating_hygiene)
            "review_rating_service_speed" -> sharedString(SR.strings.review_rating_service_speed)
            "review_rating_price" -> sharedString(SR.strings.review_rating_price)
            "review_rating_accessibility" -> sharedString(SR.strings.review_rating_accessibility)
            "review_rating_effectiveness" -> sharedString(SR.strings.review_rating_effectiveness)
            "review_rating_service_consultation" -> sharedString(SR.strings.review_rating_service_consultation)
            "review_rating_packaging_transport" -> sharedString(SR.strings.review_rating_packaging_transport)
            else -> labelKey
        }
    } catch (e: Exception) {
        labelKey
    }
}

@Composable
private fun getCouldBeBetterAspectLabel(aspect: ReviewCouldBeBetterAspect): String {
    return when (aspect) {
        ReviewCouldBeBetterAspect.PRICE -> sharedString(SR.strings.review_could_better_price)
        ReviewCouldBeBetterAspect.PICKUP_TIME -> sharedString(SR.strings.review_could_better_pickup_time)
        ReviewCouldBeBetterAspect.BAG_VARIETY -> sharedString(SR.strings.review_could_better_bag_variety)
        ReviewCouldBeBetterAspect.PACKAGING -> sharedString(SR.strings.review_could_better_packaging)
        ReviewCouldBeBetterAspect.STAFF_ATTITUDE -> sharedString(SR.strings.review_could_better_staff_attitude)
    }
}

@Composable
fun LeaveReviewView(viewModel: LeaveReviewViewModel) {
    BottomSheetUIView(
        viewModel = viewModel,
        showTopBar = true,
        navigationContent = null
    ) { uiState ->
        val state = uiState.value
        val commentFocusRequester = remember { FocusRequester() }
        Column(modifier = Modifier.fillMaxSize()) {
                Column(
                    modifier = Modifier
                        .weight(1f)
                        .verticalScroll(rememberScrollState())
                        .scrollEdgeFade()
                        .padding(start = p16, end = p16, top = p24, bottom = 8.dp + p56),
                verticalArrangement = Arrangement.spacedBy(32.dp)
            ) {
                // Заглавие под навигационната лента (както беше преди)
                Box(
                    modifier = Modifier
                        .fillMaxWidth(),
                    contentAlignment = Alignment.CenterStart
                ) {
                    Texts.DisplaySmall(
                        text = sharedString(SR.strings.how_was_your_experience),
                        color = AppTheme.current.colors.onSurface,
                        textAlign = TextAlign.Start,
                        maxLines = 2
                    )
                }

                // Frame 26080554: 4 category rows, itemSpacing 32
                val categories = state.reviewCategories
                val ratings = listOf(
                    state.ratingCollectionExperience,
                    state.ratingFoodQuality,
                    state.ratingVarietyOfContents,
                    state.ratingFoodQuantity
                )
                val defaultCategories = listOf(
                    "review_rating_taste" to sharedString(SR.strings.review_rating_taste),
                    "review_rating_quality" to sharedString(SR.strings.review_rating_quality),
                    "review_rating_freshness" to sharedString(SR.strings.review_rating_freshness),
                    "review_rating_value" to sharedString(SR.strings.review_rating_value)
                )
                val displayCategories = if (categories.size == 4) {
                    categories.mapIndexed { i, c -> c.key to getReviewCategoryLabel(c.labelKey) }
                } else {
                    defaultCategories
                }

                displayCategories.forEachIndexed { index, pair ->
                    val (key, label) = pair
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(p12)
                    ) {
                        Texts.TitleMedium(
                            text = label,
                            color = AppTheme.current.colors.onSurface
                        )
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(p12),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            repeat(5) { starIndex ->
                                val value = starIndex + 1
                                StarIcon(
                                    filled = value <= (ratings.getOrNull(index) ?: 0),
                                    onClick = { viewModel.onRatingChanged(key, value) }
                                )
                            }
                        }
                    }
                }

                // "Could be better?" (optional) + chips — Figma: up to 3 rows, 8dp spacing, 12/20 padding; selected = primary + white text, unselected = surface + grey border + primary text
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(p16)
                ) {
                    Texts.LabelLarge(
                        text = sharedString(SR.strings.could_be_better_optional),
                        color = AppTheme.current.colors.onSurface
                    )
                    val colors = AppTheme.current.colors
                    val chipShape = RoundedCornerShape(57.dp)
                    FlowRow(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(p8),
                        verticalArrangement = Arrangement.spacedBy(p8)
                    ) {
                        val selectedIds = state.selectedCouldBeBetterAspectIds
                        ReviewCouldBeBetterAspect.all.forEach { aspect ->
                            val isSelected = aspect.name in selectedIds
                            val canSelect = selectedIds.size < ReviewCouldBeBetterAspect.MAX_SELECTION || isSelected
                            Box(
                                modifier = Modifier
                                    .height(44.dp)
                                    .clickable(enabled = canSelect) {
                                        viewModel.onCouldBeBetterChipToggled(aspect.name)
                                    }
                                    .then(
                                        if (isSelected) Modifier.background(colors.secondaryContainer, chipShape)
                                        else Modifier
                                            .background(colors.surface, chipShape)
                                            .border(1.dp, colors.outlineVariant, chipShape)
                                    )
                                    .padding(horizontal = 20.dp, vertical = 12.dp),
                                contentAlignment = Alignment.Center
                            ) {
                                Texts.TitleSmall(
                                    text = getCouldBeBetterAspectLabel(aspect),
                                    color = if (isSelected) colors.onPrimary else colors.secondaryContainer
                                )
                            }
                        }
                    }
                }

                // Add comment (optional) — label + multiline field (4 lines, max 200 chars)
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(p12)
                ) {
                    Texts.LabelLarge(
                        text = sharedString(SR.strings.add_comment),
                        color = AppTheme.current.colors.onSurface
                    )

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .heightIn(min = 96.dp)
                            .background(
                                color = AppTheme.current.colors.surface,
                                shape = RoundedCornerShape(p12)
                            )
                            .border(1.dp, AppTheme.current.colors.outlineVariant, RoundedCornerShape(p12))
                            .clickable(
                                indication = null,
                                interactionSource = remember { MutableInteractionSource() }
                            ) {
                                commentFocusRequester.requestFocus()
                            }
                            .padding(p16)
                    ) {
                        BasicTextField(
                            value = state.comment,
                            onValueChange = { viewModel.onCommentChanged(it) },
                            modifier = Modifier
                                .fillMaxWidth()
                                .focusRequester(commentFocusRequester),
                            maxLines = 4,
                            singleLine = false,
                            textStyle = TextStyle(
                                fontFamily = carosoft,
                                fontWeight = FontWeight.Light,
                                fontSize = 16.sp,
                                lineHeight = 24.sp,
                                color = AppTheme.current.colors.onSurface
                            ),
                            cursorBrush = SolidColor(AppTheme.current.colors.primary),
                            decorationBox = { inner -> inner() }
                        )
                    }
                }

                if (state.isError) {
                    Texts.BodySmall(
                        text = state.errorMessage,
                        color = AppTheme.current.colors.error
                    )
                }
            }

                // Fixed button at bottom: same spacing as "Add your first location" (p8 + safe area bottom)
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(start = p16, end = p16, bottom = p8 ),
                    verticalArrangement = Arrangement.spacedBy(0.dp)
                ) {
                    DefaultButton(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(p56),
                        caption = sharedString(SR.strings.submit_review),
                        size = DefaultButtonSize.LARGE,
                        type = DefaultButtonType.PRIMARY,
                        enabled = !state.isSubmittingReview &&
                                state.ratingCollectionExperience > 0 &&
                                state.ratingFoodQuality > 0 &&
                                state.ratingVarietyOfContents > 0 &&
                                state.ratingFoodQuantity > 0,
                        callback = { viewModel.onSubmitReviewClick() },
                        cornerRadius = 100.dp
                    )
                }
            }
    }
}
